import React, { useState } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import IOSInstallInstructions from './IOSInstallInstructions';

/**
 * Dashboard inline install card.
 * Shows on 2nd+ visit when not installed and not dismissed.
 */
export default function DashboardInstallCard() {
  const { canInstall, ios, shouldShow, triggerInstall, dismiss } = usePWAInstall();
  const [showIOS, setShowIOS] = useState(false);
  const [hidden, setHidden] = useState(false);

  const visitCount = parseInt(localStorage.getItem('visit_count') || '0', 10);

  // Only show on 2nd+ visit, not installed, not dismissed
  if (!shouldShow || hidden || visitCount < 2) return null;
  // On Android, only show if browser supports install
  if (!ios && !canInstall) return null;

  const handleInstall = async () => {
    if (ios) {
      setShowIOS(true);
    } else if (canInstall) {
      const accepted = await triggerInstall();
      if (accepted) setHidden(true);
    }
  };

  const handleDismiss = () => {
    dismiss();
    setHidden(true);
  };

  if (showIOS) {
    return <IOSInstallInstructions onDismiss={() => { setShowIOS(false); handleDismiss(); }} />;
  }

  return (
    <div className="rounded-xl p-4 mb-5 flex items-center gap-3"
      style={{ backgroundColor: '#2a2a2a', border: '1px solid #333' }}
      data-testid="dashboard-install-card">
      <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: 'rgba(240,185,11,0.15)' }}>
        <svg className="w-5 h-5" fill="none" stroke="#f0b90b" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium" style={{ color: '#e8e3db' }}>Install TipMe as an app</p>
        <p className="text-xs" style={{ color: '#888' }}>Faster access from your home screen</p>
      </div>
      <button onClick={handleInstall}
        className="text-xs font-semibold px-3 py-1.5 rounded-lg whitespace-nowrap"
        style={{ backgroundColor: '#f0b90b', color: '#1a1a1a' }}
        data-testid="dashboard-install-btn">
        Add
      </button>
      <button onClick={handleDismiss}
        className="text-xs px-1 py-1"
        style={{ color: '#666' }}
        data-testid="dashboard-install-dismiss">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
